export default __webpack_public_path__ + "static/media/Spinner.dd41c0bd.gif";